// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Option_modal-scroll__Hv1jg","container":"Option_container__fZetD"};